import type { FC } from 'react';
import { Card, Stack, styled, Typography } from '@mui/material';
import { Button, Iconify } from '@pflegenavi/web-components';
import { DirectDebitStatus } from '@pflegenavi/shared/api';
import { useTranslation } from 'react-i18next';

export interface CancelDirectDebitMangopayViewProps {
  status: DirectDebitStatus;
  onCancelClick: () => void;
  isDisabled?: boolean;
}

export const CancelDirectDebitMangopayView: FC<
  CancelDirectDebitMangopayViewProps
> = ({ status, onCancelClick, isDisabled = false }) => {
  const { t } = useTranslation();

  if (status === DirectDebitStatus.Inactive) {
    return null;
  }

  return (
    <RootContainer>
      <Typography fontWeight={700} sx={{ ml: 1 }} gutterBottom>
        {t('mobile.family-member.status-update')}
      </Typography>
      <ContentContainer alignItems="stretch" spacing={2}>
        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
          {t('mobile.family-member.direct-debit-ready-to-use')}
        </Typography>
        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
          {t('mobile.family-member.direct-debit-want-to-cancel')}
        </Typography>

        <Stack alignItems="flex-end">
          <Button
            onClick={onCancelClick}
            variant="contained"
            color="error"
            disabled={isDisabled}
            endIcon={<Iconify icon="bx:x" color="white" />}
          >
            {t('direct-debit.cancel')}
          </Button>
        </Stack>
      </ContentContainer>
    </RootContainer>
  );
};

const RootContainer = styled(Card)(({ theme }) =>
  theme.unstable_sx({
    p: 1,
    pt: 2,
    width: '100%',
    borderRadius: 3,
  })
);

const ContentContainer = styled(Stack)(({ theme }) =>
  theme.unstable_sx({
    bgcolor: 'grey.200',
    paddingX: 2,
    paddingY: 3,
    pb: 2,
    borderRadius: 3,
  })
);
